"use client";
import { loadStripe } from "@stripe/stripe-js/pure";
import { useEffect, useState } from "react";

import React from "react";

type Props = {
  clientSecret: string;
  onPaymentCompletionCallback?: () => void;
};
var stripeClient;

loadStripe(process.env.NEXT_PUBLIC_STRIPE_PK!).then((stripe) => {
  stripeClient = stripe;
});
var lastCheckoutObject: any = undefined;
export default function EmbeddedStripe({
  clientSecret,
  onPaymentCompletionCallback,
}: Props) {
  useEffect(() => {
    if (clientSecret == undefined) {
      return;
    }
    const callit = async () => {
      if (lastCheckoutObject != undefined)
        (lastCheckoutObject as any)!.destroy();

      const checkout = await stripeClient!.initEmbeddedCheckout({
        clientSecret,
        onComplete: () => {
          onPaymentCompletionCallback?.();
        },
      });
      lastCheckoutObject = checkout;
      const checkoutElement = document.getElementById("checkout");
      checkoutElement!.innerHTML = "";
      checkout.mount("#checkout");
    };

    callit();
  }, [clientSecret]);

  return (
    <div className="flex h-full w-full">
      <div id="checkout" className="flex h-full w-full"></div>
    </div>
  );
}
